import { CareerHubVersion } from 'src/logic/features/api-configuration/api-configuration.reducer';
import {
    AttachmentEntity,
    getDelOrBlobPath,
} from 'src/logic/features/attachments/attachment.service';

export const createAttachmentDownloadUrl = (
    version: CareerHubVersion,
    entity: AttachmentEntity,
    storedFileId: number
) => getDelOrBlobPath(version, entity, storedFileId);
